import { render } from "./GovernoratesListing.vue?vue&type=template&id=5939edf2&ts=true"
import script from "./GovernoratesListing.vue?vue&type=script&lang=ts"
export * from "./GovernoratesListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__